import axios from 'axios';

const getChartDataApi = (url: string) => {
  return axios.get(url);
};

export { getChartDataApi };
